import { createFileRoute } from "@tanstack/react-router";

import { MonitorSection } from "../components/regulation/monitor/MonitorSection";

/**
 * The Monitor draws its own one-row header (title, status tabs, search and
 * filter, whether the watch ran, the monitoring switch), as Findings does,
 * so the compliance breadcrumb strip stays off this page.
 */
export const Route = createFileRoute("/$org/compliance/regulatory")({
  component: MonitorSection,
});
